interface RadioOptionProps {
    name: string;
    value: string;
    label: string;
    isChecked: boolean;
    onSelect: () => void;
    "data-testid"?: string;
}

const RadioOption = (props: RadioOptionProps) => (
    <label className="flex items-center gap-s cursor-pointer text-l text-p6-grey-dark">
        <input
            type="radio"
            name={props.name}
            value={props.value}
            checked={props.isChecked}
            onChange={props.onSelect}
            data-testid={props["data-testid"]}
            className="sr-only peer"
        />
        <span
            aria-hidden
            className={`flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-circle border peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-p6-orange ${
                props.isChecked ? "border-p6-orange" : "border-p6-grey-dark"
            }`}
        >
            {props.isChecked && <span className="h-[12px] w-[12px] rounded-circle bg-p6-orange" />}
        </span>
        <span>{props.label}</span>
    </label>
);

export default RadioOption;
